import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AppDownloadService {

  constructor(private http: HttpClient) { }
  ReadAppDownload(params): Observable<any> {
    return this.http.post<number>(`${environment.apiIotUrl}/app/download/read`, params);
  }
  UpdateAppDownload(params): Observable<any> {
    return this.http.post<number>(`${environment.apiIotUrl}/app/download/save`, params);
  }
}
